<script>
import RecruitContent from "@/components/career/RecruitContent.vue";

export default {
  name: "Staff01",
  components: {RecruitContent},
  data(){
    return {
      heading : '',
      heading01: ''
    }
  },
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize(){
      const headingPc01 = '自動車部品から樹脂部品へ。\n解析対象を広げるべく\nクレハに入社。'
      const headingMb01 = '自動車部品から樹脂部品へ。\n解析対象を広げるべくクレハに入社。'
      if(window.innerWidth <= 900){
        this.heading = `自動車製造のノウハウを応用。\n成功の鍵は多様性を受け入れる風土。`
        this.heading01 = headingMb01
      }else{
        this.heading = `自動車製造のノウハウを応用。\n成功の鍵は\n多様性を受け入れる風土。`
        this.heading01 = headingPc01
      }
    }
  }
}
</script>

<template>
<div>
  <recruit-content
      :tags="'#CAE解析 #PGA樹脂 #後輩育成'"
      title="研究開発"
      description01="自動車業界から化学メーカーへ。"
      description02="ノウハウをクレハで遺憾無く発揮。"
      join-year="2021"
      name="菅原 一也"
      office="樹脂加工研究所"
      :banner="require('@/assets/img/career/01/hero.jpg')"
      :banner-sp="require('@/assets/img/career/01/hero-sp.jpg')"
      :answer-heading01="heading01"
      answer-paragraph01="前職では、CAE解析というコンピュータ上のシミュレーション技術を用いて自動車部品の設計開発を行っていました。自動車部品のほとんどは金属素材。長年同じ素材を扱う中で、CAE解析のスキルを金属以外の素材にも活かしていきたいという思いが強くなっていきました。そんな中で出会ったのがクレハの樹脂加工研究所です。樹脂素材をメインで取り扱うことはもちろん、加工分野の知見を深められる点も、私にとって魅力的なポイントでした。前職では、金属部品の設計に関するスキルは身につけられたものの、次の工程である加工分野の知識は浅かったため、自身のスキルアップのために、今まで経験のない領域にも飛び込もうと思ったんです。最終的な入社の決め手は、社員のチャレンジを後押ししてくれる社風です。面接で執行役員の方とお話しした際に「お互いの力を出し合いながら、新しいものを作っていきましょう」と言っていただいたのを今でも覚えています。CAE解析の専門スキルを用いて、自分の可能性を広げたい思いがあったので、この会社ならそれが叶えられると感じました。"
      :answer-image01="require('@/assets/img/career/01/image-01.jpg')"
      :answer-heading02="heading"
      :answer-image02="require('@/assets/img/career/01/image-02.jpg')"
      answer-paragraph02="CAE解析技術を用いた樹脂部品の開発を行っています。私が担当しているのは、PGA樹脂製の「フラックプラグ」と呼ばれる部品。この部品はシェールオイル・ガスの掘削現場で使用され、優れた生分解性によって環境にも優しい、クレハを代表する製品です。前職とはまったく異なる素材を取り扱うことになり、入社当初は自分のスキルが通用するのか不安でした。しかし、ある時自動車業界でよく用いられる開発期間の短縮方法を樹脂加工にも取り入れると、思いの外うまくいったんです。他業界出身者としての経験をクレハに還元できたことが非常に嬉しかったですね。新しい開発方法をここまでスムーズに応用できたのは、クレハの社員一人ひとりが新たな挑戦に前向きだったからこそだと思います。樹脂加工研究所の人財は、化学分野の専門家はもちろん、私のような機械畑出身や電気系を学んできた人など様々。そのため、互いの考え方を受け入れながら議論する土壌が形成されているのです。自分では考えもしなかったアイデアに出会うことも多々あり、とても刺激的な仕事環境だと感じています。"
      :answer-image03="require('@/assets/img/career/01/image-04.jpg')"
      :answer-heading03="'PGA樹脂の可能性を広げ、\n若手の活躍を後押しする。'"
      answer-paragraph03="まずは現在開発しているフラックプラグの生産を軌道に乗せることが直近の目標です。長期的な目標としては、前職での経験やスキルを活かして、フラックプラグの市場拡大を目指したいと考えています。また、高強度かつ優れた生分解性を持つPGA樹脂の可能性を広げるべく、フラックプラグ以外の製品開発にも挑戦したいですね。クレハは素材だけでなく加工技術にも高い独自性を誇っているので、それらを活かしてクレハを代表する製品を生み出せたらと思います。さらに、研究のグループリーダーとして、後輩育成にも力を入れたいと考えています。クレハの優秀な技術者たちに世界で活躍してもらいたい。そんな思いから、DXやAIを導入して彼らのパフォーマンスを最大化できる研究環境を整えています。しかし、優秀な技術者を育てていくためには、環境を整えるだけでは不十分で、若手のチャレンジを後押しする風土が大切になってくると思っています。ここで肝となるのが、「応援」で終わらないこと。チャレンジに寛容になるだけではなく、やり切るまで面倒を見る。成功や失敗に関係なく、やり切るまでを後輩に経験させることが、次なる学びに繋がる。そう信じて、今後も後輩のチャレンジをサポートしていきたいと思います。"
      :banner-full="require('@/assets/img/career/01/image-03.jpg')"
      :banner-full-sp="require('@/assets/img/career/01/image-03-sp.jpg')"
  />
</div>
</template>

<style scoped lang="scss">

</style>
